import type { ComparisonConfig } from './ComparisonPage';

const OPERA_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io vs Oracle OPERA',
  heroSubtitle: 'Oracle OPERAは数十年前に構築されたレガシー業界標準であり、エンタープライズ時代の複雑さと料金を引き継いでいます。HotelStack.ioは、より多くのモジュール、シンプルな料金、インフラオーバーヘッドゼロのモダンなクラウドネイティブ代替を提供します。',
  overviewComparison: [
    { label: 'アーキテクチャ', hotelstack: 'クラウドネイティブSaaS', competitor: 'レガシーオンプレミス/クラウド' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$500以上＋ライセンス' },
    { label: '導入', hotelstack: '無料 — 48時間オンボーディング', competitor: '3〜6か月の導入' },
    { label: 'モジュール総数', hotelstack: '36内蔵', competitor: '20以上（個別ライセンス）' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '別途OPERA POSライセンス' },
    { label: '対象セグメント', hotelstack: '中小企業からエンタープライズ', competitor: 'エンタープライズのみ' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: true },
        { name: 'グループ予約', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: 'アドオン' },
      ],
    },
    {
      category: 'クラウド・アクセシビリティ',
      features: [
        { name: '真のクラウドネイティブ', hotelstack: true, competitor: 'ハイブリッド' },
        { name: 'サーバーメンテナンスゼロ', hotelstack: true, competitor: false },
        { name: 'リアルタイムマルチデバイス同期', hotelstack: true, competitor: '制限あり' },
        { name: 'モダンレスポンシブUI', hotelstack: true, competitor: false },
        { name: '自動アップデート', hotelstack: true, competitor: false },
        { name: 'ITスタッフ不要', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レベニューマネジメント',
      features: [
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: true },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: 'Oracle BI経由' },
        { name: '需要予測', hotelstack: true, competitor: true },
        { name: 'RevPAR分析', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B・オペレーション',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: '別ライセンス' },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: '別ライセンス' },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: 'インテグレーション経由' },
      ],
    },
    {
      category: 'コスト・オンボーディング',
      features: [
        { name: '無料オンボーディング', hotelstack: true, competitor: false },
        { name: '無料データ移行', hotelstack: true, competitor: false },
        { name: 'サーバー費用なし', hotelstack: true, competitor: false },
        { name: 'ライセンス費用なし', hotelstack: true, competitor: false },
        { name: '地域通貨料金設定', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: 'アドオン' },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: 'アドオン' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: 'アドオン' },
        { name: 'レストラン予約', hotelstack: true, competitor: 'Microsアドオン' },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: 'インテグレーション経由' },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: '36モジュールすべて含む。ライセンス費用なし。サーバー費用なし。無料オンボーディングと移行。EUR、GBP、AED、INR、THBでの地域別料金設定。',
    competitorNote: '施設あたり月額$500以上のエンタープライズライセンス。POS、S&C、OCRMは別ライセンス。導入費用$50,000以上。クラシック版にはオンプレミスサーバーが必要。',
  },
  advantages: [
    '総所有コストが90%以上削減 — ライセンス費用、サーバー費用、導入費用なし',
    'OPERAの3〜6か月の導入期間に対して48時間で稼働開始',
    'どのデバイスからもアクセス可能なモダンクラウドネイティブUI — デスクトップクライアント不要',
    'OPERAの個別モジュールライセンスに対して、全36モジュールを1つのサブスクリプションに含む',
    'ITインフラゼロ — サーバー、パッチ、Oracle DBA不要',
    '別途OPERA POSライセンスに対して、追加費用なしの内蔵F&BとPOS',
    '6通貨での地域別料金設定でホテルは現地通貨で支払い',
    '専任サポートチーム付きのOPERAからの無料データ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'Oracle OPERAは数十年にわたり業界標準であり、既存のOracleインフラを持つ大規模エンタープライズチェーンには依然として堅実な選択肢です。しかし、大多数のホテルにとって、HotelStack.ioはOPERAが要求する数か月の導入サイクル、サーバーオーバーヘッド、複雑なライセンスなしに、より多くのモジュール、優れたUX、劇的に低いコストを提供します。',
    bestFor: [
      '高額なOracleライセンスとインフラコストを排除したいホテル',
      '遅いOPERAの導入・アップグレードサイクルに疲れた施設',
      'デスクトップクライアント依存なしのモダンクラウドネイティブUIが必要なホテル',
      'OPERAエンタープライズプランでは予算が合わない中小規模の施設',
      '個別ライセンス費用なしですべてのモジュールを含めたい施設',
    ],
  },
  faqItems: [
    { question: 'Oracle OPERAからHotelStack.ioに移行できますか？', answer: '当社の移行チームはOPERAからHotelStackへの移行を専門としています。ゲストプロファイル、予約履歴、レートコード、客室設定、グループブロックをインポートします。移行は無料で、通常48〜72時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioはOPERAと同じインテグレーションをサポートしていますか？', answer: 'HotelStack.ioは100以上のOTA、AmadeusとSabre経由のGDS、主要決済ゲートウェイに接続します。インテグレーションマーケットプレイスは同じエコシステムをカバーしています。カスタムインテグレーション用のオープンAPIも提供しています。' },
    { question: 'OPERA CloudとHotelStack.ioはどう比較されますか？', answer: 'OPERA CloudはOracleがレガシー製品をモダナイズしたものです。HotelStack.ioは最新の技術スタックで最初からクラウドネイティブに構築されました。より多くのモジュール（36対OPERA Cloudベース）、シンプルな料金、迅速なオンボーディング、Oracleインフラへの依存なしを提供します。' },
    { question: '現在OPERAを使用している大規模ホテルチェーンにHotelStack.ioは適していますか？', answer: 'はい。チェーンおよびエンタープライズプランは、一元分析、レート配信、ブランド基準を備えたマルチプロパティ管理をサポートしています — 大規模チェーンがOPERAを使い続ける同じ機能を、わずかなコストで提供します。' },
  ],
};

const RMS_CLOUD_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io vs RMS Cloud',
  heroSubtitle: 'RMS CloudはAPACホスピタリティ市場に堅実なPMS基盤で対応しています。HotelStack.ioは36モジュール、グローバル多通貨料金、内蔵F&B/POS、高度なレベニューマネジメントで、より低価格でそれを拡張します。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36の統合モジュール', competitor: '12以上のモジュール' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$80以上' },
    { label: 'グローバル展開', hotelstack: '40か国以上', competitor: '主にAPAC' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: 'レベニューマネジメント', hotelstack: '高度（内蔵）', competitor: '基本' },
    { label: '予約エンジン', hotelstack: 'BookMyRoom.io（無料）', competitor: '基本ウィジェット' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'クラウドベースPMS', hotelstack: true, competitor: true },
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'グループ予約', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: '制限あり' },
      ],
    },
    {
      category: '収益・流通',
      features: [
        { name: 'チャネルマネージャー（100以上のOTA）', hotelstack: true, competitor: '限定OTA' },
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: '基本' },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'ゲスト管理',
      features: [
        { name: '360度ゲストプロファイル', hotelstack: true, competitor: '基本' },
        { name: 'ロイヤルティプログラム管理', hotelstack: true, competitor: false },
        { name: 'ゲストコミュニケーション自動化', hotelstack: true, competitor: '制限あり' },
        { name: 'ゲスト消費分析', hotelstack: true, competitor: false },
        { name: 'ID/本人確認アップロード', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'F&B・オペレーション',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: true },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング・給与', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'マルチプロパティ・コンプライアンス',
      features: [
        { name: 'チェーンダッシュボード', hotelstack: true, competitor: true },
        { name: 'クロスプロパティ分析', hotelstack: true, competitor: '制限あり' },
        { name: '多通貨請求', hotelstack: true, competitor: 'AUD中心' },
        { name: '地域税コンプライアンス', hotelstack: true, competitor: 'APACのみ' },
        { name: 'GDPRデータ保護', hotelstack: true, competitor: '制限あり' },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: '制限あり' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: '36モジュールすべて含む。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングとデータ移行。',
    competitorNote: '月額$80以上のAUDベース料金。チャネルマネージャーとプレミアム機能は追加料金。主にAPACサポート。',
  },
  advantages: [
    'モジュール数が約3倍（36対12以上）、より低価格ですべての機能を含む',
    'RMS CloudのAPAC市場フォーカスに対して、40か国以上のグローバルカバレッジ',
    'POSターミナル、ルームサービス、キッチン管理を含む完全なF&Bモジュール',
    'ダイナミックプライシング、予測、シミュレーターを備えた高度なレベニューマネジメント',
    'AmadeusとSabre経由のGDSを含む100以上のOTAとのより強力なチャネル接続',
    'スケジューリング、給与、勤怠、パフォーマンス追跡を含むスタッフ管理',
    '主にAUDベースの料金に対して6通貨での多通貨請求',
    '24時間365日専任サポート付きの無料オンボーディングとデータ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'RMS Cloudは宿泊施設管理の堅実な基盤を持つAPAC施設向けの有能なPMSです。HotelStack.ioは36モジュール、グローバルリーチ、高度なレベニューマネジメント、完全なF&B/POS機能を備えた、より包括的なソリューションを低価格で提供します。基本的なPMSを超えてフルホテルオペレーション管理を求める施設にとって、HotelStack.ioがより強力な選択肢です。',
    bestFor: [
      '基本的なPMSを超えた完全なオールインワンプラットフォームを求めるホテル',
      'F&B、POS、キッチン管理が内蔵されている必要がある施設',
      'グローバルコンプライアンスと流通が必要なAPAC外への拡大を行うホテル',
      '高度なレベニューマネジメントとダイナミックプライシングを求める施設',
      'グローバル施設全体での一元分析が必要なマルチプロパティチェーン',
    ],
  },
  faqItems: [
    { question: 'RMS CloudからHotelStack.ioに移行できますか？', answer: '当社の移行チームがゲストプロファイル、予約履歴、レート設定、客室セットアップを含むRMS Cloudからの完全なデータ移行を担当します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioはオーストラリアとAPACのホテルに適していますか？', answer: 'もちろんです。HotelStack.ioはAUDを含む多通貨請求、APAC市場向けの地域税コンプライアンス、APACフォーカスのOTAへの接続をサポートしています。多くのAPAC施設が追加モジュールとグローバルリーチのためにRMS Cloudから乗り換えています。' },
    { question: 'RMS CloudとHotelStack.ioの料金比較は？', answer: 'HotelStack.ioは月額$49からで36モジュールすべて含み、6通貨での地域別料金設定。RMS Cloudは月額約$80以上（AUD）で、より少ないモジュール、チャネル管理とプレミアム機能は追加料金。' },
    { question: 'HotelStack.ioはRMS Cloudのようにホリデーパークやキャンプ場をサポートしていますか？', answer: 'HotelStack.ioはホテル、リゾート、ホステル、ブティック施設、サービスアパートメントを含むすべての宿泊施設タイプ向けに設計されています。RMS Cloudにはホリデーパーク固有の機能がありますが、HotelStack.ioの柔軟な施設設定は多様な宿泊モデルをサポートします。' },
  ],
};

export const COMPARISON_JA_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_JA,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_JA,
};
